import { useMutation } from '@vue/apollo-composable'
import { SetMatchVisibilityMutation } from '@/features/infringement/components/Match.vue'
import { ToastType, useToastStore } from '@/shared/stores/toast'

export function useMatchVisibility() {
  const toastStore = useToastStore()
  const { mutate } = useMutation(SetMatchVisibilityMutation, {
    clientId: 'router',
  })

  const setHidden = async (
    reportId: string,
    matchId: string,
    hidden: boolean
  ) => {
    try {
      await mutate({ input: { reportId, matchId, hidden } })
      return true
    } catch (error) {
      toastStore.showToast({
        type: ToastType.Error,
        content: 'Could not update match visibility',
        error: error as Error,
      })
      return false
    }
  }

  return { setHidden }
}
